import { customElement } from 'lit/decorators.js';

// Re-exporting extra Lit modules so their imports can be optimized in the web-component bundle build process
// No idea why rollup can't do the same with the just using the 'lit' package,
// but this works with 'utils' package workaround
export * from 'lit/decorators.js';
export { unsafeStatic, html as htmlStatic } from 'lit/static-html.js';
export * from './base-lit-element.js';
export * from './default-property.js';

/**
 * Registers a custom element if it doesn't already exist.
 * Used for registering web components.
 *
 * @param {string} tagName
 * @return {*}
 *
 * @example registerCustomElementSafely('ids-button')(IdsButton);
 */
export const registerCustomElementSafely = (
    tagName: string,
): ((constructor: CustomElementConstructor) => void) => {
    return function (constructor: CustomElementConstructor): void {
        if (!customElements.get(tagName)) {
            customElement(tagName)(constructor);
        }
    };
};
